import { formatNumber } from '.';

export const summaryFeeDescription = ({
  currencySymbol,
  fee,
  feeType,
  numberOfTicketsWithFee,
  intl,
}: {
  currencySymbol: string;
  fee: number;
  feeType: string;
  numberOfTicketsWithFee: number;
  intl: any;
}) => {
  const feeDescriptor =
    feeType == 'bookingFee'
      ? intl.formatMessage({
          id: 'checkout.summary.bookingFee',
        })
      : '';
  const formattedFee = formatNumber(fee);

  return (
    `${currencySymbol}${formattedFee} ${feeDescriptor}` +
    ' (\u00D7' +
    `${numberOfTicketsWithFee})`
  );
};

export const summaryTicketsDescription = ({
  currencySymbol,
  eventPrice,
  numberOfTickets,
  intl,
}: {
  currencySymbol: string;
  eventPrice: number;
  numberOfTickets: number;
  intl: any;
}) => {
  const ticketOrTicketsIntl =
    numberOfTickets > 1 ? 'checkout.tickets' : 'checkout.ticket';
  const formattedPrice = formatNumber(eventPrice);

  return (
    `${currencySymbol}${formattedPrice}` +
    ' \u00D7 ' +
    `${numberOfTickets}${' '}${intl.formatMessage({
      id: ticketOrTicketsIntl,
    })}`
  );
};
